import { useMemo, useCallback } from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { useAppDispatch } from "../../../../../../../redux/hooks";
import { updateOperationProfileProperty } from "../../../../../../../redux/reducers/user/profile/userProfile";
import { compileNameOfProperty, getGenericPayloadFromEvent } from "../../../../../../../utils";
import { FormField } from "../../../../../../common/fields/fields";
import { TitleH6 } from "../../../../../../common/titles/titles";
import { UserProfileOperationEmailItem } from "./item/item";
import { UserSignupOperationEmailsStyle } from "./listStyle.jss";
import { IAdminData } from "../../../../../../../models";
import { ColorType } from "../../../../../../../common/enum/ColorType";

interface IUserProfileOperationEmailsProps {
    data: IAdminData;
    adminRegister: UseFormRegister<IAdminData>;
    adminErrors: FieldErrors<IAdminData>;
}

export const UserProfileOperationEmails: React.FC<IUserProfileOperationEmailsProps> = ({ data, adminErrors, adminRegister }) => {
    const theme = useTheme();
    const style = UserSignupOperationEmailsStyle({ theme });
    const dispatch = useAppDispatch();
    const { t } = useTranslation("common");

    const onInputChange = useCallback(
        (event) => {
            const payload = getGenericPayloadFromEvent(event);
            dispatch(updateOperationProfileProperty(payload));
        },
        [dispatch],
    );

    const maxIndex = useMemo(() => {
        return data.emails.length - 1;
    }, [data.emails]);

    return (
        <>
            <div className={style.row}>
                <div className={style.title}>
                    <TitleH6
                        title={t("USER.TITLES.OPERATION_DEPARTMENT")}
                        color={ColorType.primary}
                    />
                </div>
            </div>
            <div className={style.row}>
                <div className={style.column}>
                    <FormField
                        type="text"
                        label={t("USER.SIGNUP.LANDLINE")}
                        value={data.phone}
                        error={adminErrors.phone}
                        isRequired={true}
                        {...adminRegister(compileNameOfProperty<IAdminData>("phone"), { onChange: onInputChange, value: data.phone })}
                    />
                </div>
                <div className={style.column}>
                    <FormField
                        type="text"
                        label={t("USER.SIGNUP.MOBILE_PHONE")}
                        value={data.mobilePhone}
                        error={adminErrors.mobilePhone}
                        {...adminRegister(compileNameOfProperty<IAdminData>("mobilePhone"), {
                            onChange: onInputChange,
                            value: data.mobilePhone,
                        })}
                    />
                </div>
            </div>
            <div className={style.rowEmails}>
                {data.emails.map((email, index) => (
                    <div
                        className={style.columnEmail}
                        key={`${UserProfileOperationEmails.name}-${index}`}
                    >
                        <UserProfileOperationEmailItem
                            email={email}
                            key={`${UserProfileOperationEmails.name}-${index}`}
                            isLastIndex={index === maxIndex}
                            isUniqueIndex={data.emails.length === 1}
                            index={index}
                        />
                    </div>
                ))}
            </div>
        </>
    );
};
